import React from "react";

const CustomBtn = ({ title, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center justify-center px-4 h-10 py-2 font-quicksand border-2 border-main bg-brandSoft text-main rounded-lg hover:bg-main hover:text-white active:scale-[.98] transition-all ease-in-out duration-200 font-bold whitespace-nowrap shadow-soft"
    >
      {title}
    </button>
  );
};

export default CustomBtn;
